import React from "react";
import qString from "query-string";
import { useLocation } from "react-router-dom";

import VendorSearchControl from "./VendorSearchControl";
import VendorList from "./VendorList";
import VendorLearn from "./VendorLearn";
import VendorCategoryPagination from "./VendorCategoryPagination";

const VendorCategorySection = props => {
  const location = useLocation();

  const shouldShowReadMore = loc => {
    let qs = qString.parse(loc.search);
    if (!!qs.p && qs.p > 1) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <section>
      <div className="middleSection vendor-category">
        {props.isDataLoaded ? (
          <div className="WidthContain">
            <div className="container">
              <div className="vendorCategories">
                <React.Fragment>
                  <VendorSearchControl {...props} />
                  <VendorList {...props} />
                  <VendorCategoryPagination isActive={false} {...props} />
                </React.Fragment>
              </div>
              {props.learn_tab &&
                props.learn_tab.show_learn_lab &&
                shouldShowReadMore(location) && <VendorLearn {...props} />}
              {/* <VendorCategoryArticle /> */}
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default VendorCategorySection;
